import React from "react";
import { LuxuryBackground, PageHero } from "../components/shared/UIComponents";

export default function PlatformRolePage() {
  return (
    <div className="relative" data-testid="platform-role-page">
      <PageHero eyebrow="Legal" title="Platform Role Disclosure" description="Understanding the role and limitations of the Imaani Capital platform." />
      <div className="relative">
        <LuxuryBackground />
        <article className="relative z-10 mx-auto max-w-4xl px-4 py-10 sm:px-6 sm:py-16 lg:px-8">
          <div className="rounded-3xl border border-cream-warm bg-white p-8 md:p-12 shadow-sm space-y-8 text-[#333] text-sm leading-7">

            <section>
              <p>Imaani Capital operates as a technology platform and capital marketplace that facilitates connections between real estate borrowers, lenders, and capital participants.</p>
              <p className="mt-3">The platform provides infrastructure designed to organize information, coordinate communication, and facilitate the evaluation of financing opportunities. Imaani Capital does not provide investment advice, legal advice, or financial planning services.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">No Investment Advice</h2>
              <p>Nothing presented on the Imaani Capital platform should be interpreted as investment advice, financial advice, tax advice, or legal advice.</p>
              <p className="mt-3">Information presented on the platform is provided for informational purposes only and should not be relied upon as a recommendation to participate in any transaction or investment opportunity.</p>
              <p className="mt-3">Users are solely responsible for evaluating the merits and risks of any transaction.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">No Broker-Dealer Activity</h2>
              <p>Unless explicitly stated in writing and where applicable regulatory licensing exists, Imaani Capital does not operate as a broker-dealer or securities intermediary.</p>
              <p className="mt-3">The platform does not:</p>
              <ul className="list-disc ml-6 mt-3 space-y-2">
                <li>solicit investments</li>
                <li>recommend specific investments</li>
                <li>provide personalized investment recommendations</li>
                <li>act as a fiduciary for platform participants</li>
              </ul>
              <p className="mt-3">Users are responsible for making their own independent financial decisions.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">No Guarantee of Financing or Investment Outcomes</h2>
              <p>Imaani Capital does not guarantee that borrowers will obtain financing or that investors will achieve any particular return or financial result.</p>
              <p className="mt-3">Participation in opportunities presented on the platform involves risk, including the possible loss of capital.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Platform as Information Infrastructure</h2>
              <p>The Imaani Capital platform provides tools for organizing deal information, facilitating introductions, and enabling communication between parties involved in real estate financing transactions.</p>
              <p className="mt-3">Borrowers, lenders, and capital participants remain responsible for conducting their own independent due diligence and negotiating the terms of any transaction.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Third-Party Information</h2>
              <p>Information presented on the platform may originate from borrowers, lenders, third-party service providers, or other external sources.</p>
              <p className="mt-3">Imaani Capital does not independently verify all submitted information and makes no representation regarding its accuracy, completeness, or reliability.</p>
              <p className="mt-3">Users should independently verify all information before relying upon it.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Independent Professional Advice</h2>
              <p>Users of the platform should consult qualified financial, legal, and tax advisors before making decisions related to lending, borrowing, or investing.</p>
              <p className="mt-3">Participation in private real estate financing opportunities may not be suitable for all individuals.</p>
            </section>

          </div>
        </article>
      </div>
    </div>
  );
}
